import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Index2 from '../Navbar2/index2'
import "./Hero8.css"

const HeroSection7 = () => {
   const [isOpen, setIsOpen] = useState(false)
  
    const toggle = () => {
      setIsOpen(!isOpen)
    }
  return (
    <div className='HeroContainer8'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='HeroBg8'>
          <Index2 toggle={toggle}/>
        </div>
    </div>
  )
}

export default HeroSection7